<template>
     <div v-if="isEditingThree === true" class="wysiwyg-submission-content" v-html="editorThree"></div>
    <q-editor
      v-if="isEditingThree === false"
      class="wysiwyg background-colour"
      paragraph-tag = "p"
      v-model="editorThree"
      :toolbar="[
        ['left', 'center', 'right'],
        ['bold', 'italic','underline'],
        ['quote', 'unordered', 'ordered']
      ]"
    />

     <div class="button-continer">
       <q-btn @click="$emit('submitQuestionThree', editorThree)"  v-if="isEditingThree === false"  color="white" text-color="black" label="Save" />
       <q-btn @click="$emit('submitQuestionThree')" v-if="isEditingThree === true" color="white" text-color="black" label="Write your answer" />
  </div>
</template>


<script>
import { onMounted, ref } from 'vue'
import { copyText } from 'vue3-clipboard'
import { useQuasar } from 'quasar'

export default {
  props: ['isEditingThree'],
  setup (props, {emit}) {

    onMounted(() => {
      if(sessionMemory.localStorage.has('questionThree')) {
        editorThree.value = sessionMemory.localStorage.getItem('questionThree')
      }
    })

    const sessionMemory = useQuasar()


    const editorThree = ref("<p>Type your answer...</p>")

    const changeMemory = (text) => {
       emit('submitQuestionThree', text)
    }

    const doCopy = () => {
        let strippedString = editor.value.replace(/(<([^>]+)>)/gi, " ").replace(/\[b\]/g, '<b>').replace(/\[\/b\]/g, '</b>')
      
        copyText(strippedString, (error, event) => {
          if (error) {
            alert('Can not copy')
            console.log(error)
          } else {
            alert('Copied')
            console.log(event)
          }
        })
    }

    return {
      editorThree,
      doCopy,
      changeMemory,
      sessionMemory,
    }
  }
}
</script>

<style lang="scss" scoped>


</style>

